import { AuthService } from './../auth/auth.service';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/internal/operators';
import { MatSnackBar } from '@angular/material/snack-bar';


import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { EmpresasService } from '../services/empresas.service';
import { UsersService } from '../services/users.service';

@Component({
    selector     : 'register',
    templateUrl  : './register.component.html',
    styleUrls    : ['./register.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class RegisterComponent implements OnInit, OnDestroy
{
    registerForm: FormGroup;
    isSuccessful = false;
    isSignUpFailed = false;
    errorMessage = '';
    durationInSeconds = 5;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private authService: AuthService,
        private _snackBar: MatSnackBar,
        private empresaService: EmpresasService,
        private userService: UsersService,
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: false
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.registerForm = this._formBuilder.group({
            name           : ['', Validators.required],
            email          : ['', [Validators.required, Validators.email]],
            nombreEmpresa  : ['', Validators.required],
            razonSocial    : ['', Validators.required],
            idFiscal       : ['', Validators.required],
            tipoId         : ['', Validators.required]
        });

        // Update the validity of the 'passwordConfirm' field
        // when the 'password' field changes
        // this.registerForm.get('password').valueChanges
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe(() => {
        //         this.registerForm.get('passwordConfirm').updateValueAndValidity();
        //     });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    onSubmit(): void {
        this.empresaService.add(this.registerForm.value).subscribe(
            data => {
                console.log(data);
                this.userService.register({...this.registerForm.value, empresa: data.body.id}).subscribe(
                    dat => {
                        console.log(dat);
                        this._snackBar.open('Se eviara un mail con credenciales.', 'close', { duration: this.durationInSeconds * 1000});
                        this.isSuccessful = true;
                        this.isSignUpFailed = false;
                    },
                    err => {
                        console.log(err);
                        this._snackBar.open('An error has ocurred', 'close', {
                            duration: this.durationInSeconds * 1000,
                        });
                        this.errorMessage = err.error.message;
                        this.isSignUpFailed = true;
                    }
                );
            },
            err => {
                this._snackBar.open('An error has ocurred', 'close', { duration: this.durationInSeconds * 1000});
                this.errorMessage = err.error.message;
                this.isSignUpFailed = true;
            }
        )
    }
}

/**
 * Confirm password validator
 *
 * @param {AbstractControl} control
 * @returns {ValidationErrors | null}
 */
export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {

    if ( !control.parent || !control )
    {
        return null;
    }

    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('passwordConfirm');

    if ( !password || !passwordConfirm )
    {
        return null;
    }

    if ( passwordConfirm.value === '' )
    {
        return null;
    }

    if ( password.value === passwordConfirm.value )
    {
        return null;
    }

    return {passwordsNotMatching: true};
};
